/**
 * Judge.me Reviews Lazy Loader — judgeme-lazy-loader.js
 * Injects review widget HTML only when the section nears the viewport.
 * UI is unchanged once loaded; min-heights in product-reviews.css hold space.
 */
(function () {
  'use strict';

  var LOADED = false;
  var LOADING = null;
  var FALLBACK_MS = 8000;
  var OBSERVER_MARGIN = '400px 0px';
  var JDGM_WAIT_MS = 10000;

  function getElements() {
    return {
      wrapper: document.querySelector('.jdgm-reviews-wrapper'),
      container: document.getElementById('judgeme_product_reviews'),
      template: document.getElementById('judgeme-widget-template'),
    };
  }

  function shouldLoadImmediately() {
    var hash = window.location.hash || '';
    return hash.indexOf('judgeme') !== -1;
  }

  function waitForJudgeme(callback, maxMs) {
    if (window.jdgm) {
      callback();
      return;
    }

    var start = Date.now();
    var timer = window.setInterval(function () {
      if (window.jdgm) {
        window.clearInterval(timer);
        callback();
        return;
      }
      if (Date.now() - start >= maxMs) {
        window.clearInterval(timer);
        callback();
      }
    }, 50);
  }

  function initJudgemeWidget(container) {
    var jdgm = window.jdgm;
    if (!jdgm) return;

    if (typeof jdgm.customizeBadges === 'function') {
      jdgm.customizeBadges();
    }
    if (typeof jdgm.loadWidgets === 'function') {
      jdgm.loadWidgets();
    } else if (typeof jdgm.initWidgets === 'function') {
      jdgm.initWidgets();
    } else if (typeof jdgm.renderAllWidgets === 'function') {
      jdgm.renderAllWidgets();
    } else if (typeof jdgm.setupWidget === 'function') {
      jdgm.setupWidget(container);
    }

    document.dispatchEvent(
      new CustomEvent('baybee:judgeme-reviews-loaded', {
        detail: { container: container },
      })
    );
  }

  function injectWidgetHtml(container, template) {
    if (!template || !template.content) return false;
    if (container.dataset.jdgmLoaded === 'true') return true;

    container.appendChild(template.content.cloneNode(true));
    container.dataset.jdgmLoaded = 'true';
    container.removeAttribute('data-jdgm-lazy');
    return true;
  }

  function loadJudgemeReviews() {
    if (LOADED) return Promise.resolve(true);
    if (LOADING) return LOADING;

    var els = getElements();
    if (!els.container || els.container.dataset.jdgmLazy !== 'true') {
      LOADED = true;
      return Promise.resolve(true);
    }
    if (!els.template) {
      LOADED = true;
      return Promise.resolve(false);
    }

    LOADING = new Promise(function (resolve) {
      injectWidgetHtml(els.container, els.template);

      if (els.wrapper) {
        els.wrapper.classList.remove('jdgm-reviews-wrapper--lazy');
      }

      waitForJudgeme(function () {
        initJudgemeWidget(els.container);
        LOADED = true;
        LOADING = null;
        resolve(true);
      }, JDGM_WAIT_MS);
    });

    return LOADING;
  }

  window.__baybeeLoadJudgemeReviews = loadJudgemeReviews;

  function setupObservers() {
    var els = getElements();
    if (!els.container || els.container.dataset.jdgmLazy !== 'true') return;

    if (shouldLoadImmediately()) {
      loadJudgemeReviews();
      return;
    }

    function triggerLoad() {
      loadJudgemeReviews();
    }

    var sectionEl = els.wrapper && els.wrapper.closest('[id*="shopify-section"]');
    if (sectionEl) {
      sectionEl.addEventListener('section:visible', triggerLoad, { once: true });
    }

    if ('IntersectionObserver' in window && els.wrapper) {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            obs.disconnect();
            triggerLoad();
          });
        },
        { rootMargin: OBSERVER_MARGIN, threshold: 0.01 }
      );

      observer.observe(els.wrapper);
    }

    window.setTimeout(triggerLoad, FALLBACK_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObservers);
  } else {
    setupObservers();
  }
})();
